import { render } from "./Player.vue?vue&type=template&id=617dcaa0&scoped=true&bindings={}"
import script from "./Player.vue?vue&type=script&lang=ts"
export * from "./Player.vue?vue&type=script&lang=ts"

import "./Player.vue?vue&type=style&index=0&id=617dcaa0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-617dcaa0"

export default script